import { render, staticRenderFns } from "./GlobalMessage.vue?vue&type=template&id=586ff332&"
import script from "./GlobalMessage.vue?vue&type=script&lang=js&"
export * from "./GlobalMessage.vue?vue&type=script&lang=js&"
import style0 from "./GlobalMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports